import type { UserPublic } from '@repo/types/users';

import { getUserLvl } from '@repo/lib/user-lvl/getUserLvl';
import { User } from 'lucide-react';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { getAvatar } from '@/utils/getAvatar';

/**
 * Props for the UserCard component.
 * @property {UserPublic} user - The public user object containing user details.
 */
interface UserCardProps {
  user: UserPublic;
}

export default function UserCard(userCardProps: UserCardProps) {
  const { user } = userCardProps;
  const { avatarURL, name, surname, lvl } = user;

  return (
    <div className={'group flex items-center justify-between gap-3 overflow-hidden rounded-sm py-2'}>
      <Avatar size={'md'}>
        <AvatarImage src={getAvatar(avatarURL)} alt={'avatar'} />
        <AvatarFallback>
          <User />
        </AvatarFallback>
      </Avatar>
      <div className={'flex w-full flex-col gap-0.5 overflow-hidden'}>
        <p className={'text-text-secondary w-full truncate text-sm'}>
          {name} {surname}
        </p>
        <small className={'text-text-tertiary text-xs'}>{getUserLvl(lvl)}</small>
      </div>
    </div>
  );
}
